import React from 'react'
import { object } from 'prop-types'
import { graphql } from 'gatsby'

import CampaignTemplate from '@/templates/campaign'

const StarterPack = ({ data: { campaign, allApp } }) => {
  return <CampaignTemplate campaign={campaign} products={allApp.nodes} />
}

StarterPack.propTypes = {
  data: object,
}

export default StarterPack

export const query = graphql`
  query {
    campaign(id: { eq: "starter-pack" }) {
      applications {
        id
        name
      }
      attributes {
        tags
      }
      description
      id
      name
    }

    allApp {
      nodes {
        id
        slug
        name
        product
        installations
        shortDescription
        category {
          id
          name
          slug
        }
        icons {
          id
          large
          original
          small
          title
        }
        customProps {
          appVideoUrl
          hiddenForBeta
          isService
          usingBeta
          isPremium
        }
        hidden
        longDescription
        tutorialUrl
        payment {
          price
          frequency
          trialDays
          perAccount
        }
      }
    }
  }
`
